import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {
  ConsumerFinanceApplication,
  ContractDetails,
  DeclineContractFn,
  GetActiveContractForApplicationFn,
  GetContractStatusFn,
  isInternalUser,
  PayloadApiResponse,
  PpsrAsset,
  PpsrAssetValue,
  VehicleDetails,
  getAppSalesforceId,
  CreateApplicationNoteFn,
  CreateNewDisbursementFn,
  UpdateDisbursementFn,
  GetDisbursementByApplicationIdFn,
  SyncDisbursementToSfFn,
  SyncBankDetailsToSfFn,
  RemoveApplicationNoteByNoteIdFn,
  GetBillerNameFn,
  ValidateBPAYFn,
  UpdateApplicationStageInSfFn,
  GetApplicationByIdFn,
  formGroupedDocumentData,
  unclassifiedDocuments,
  AzureStorageDocument,
  Application,
  GroupedDocument,
  ApiResponse,
  Disbursement,
  validateDisbursementData,
  SettleLoanFn,
  SyncPrivateSellerBankDetailsToSfFn,
  GetInstitutionNameFn,
  SyncDepositPaidToSfFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  groupStandardCondition,
  RefreshBankStatementFn,
  GetUserFn,
  GetAccountDetailsFromSfFn,
  GetBankDetailsFromOpportunitySfFn,
  LocalBankAccountDetailValue,
  ExtractTaxInvoiceFn,
  UpdateApplicationFn,
  constants,
  CreateAssetInspectionFn,
  GetAssetInspectionsForApplicationFn,
  DownloadVerimotoReportFn,
  VerimotoInspectionTableDataWithInspectionDetails,
  VerimotoLenderType,
  GetBankStatementsAnalysisFn,
  VerimotoInspectionTypeSelection,
  UpdateApplicationSfFn,
  isAdminOrCreditUserOrSalesAM,
  isAdminOrCreditUser,
  DownloadDocumentFromAzureFn,
  GetBsaLenderListFn,
  GetBsaExcludedLenderListFn,
  GetDscrCalculatorValueFn,
  UpdateDscrCalculatorValueFn,
  SaveBsaCalculatorFn,
  GetBsaCalculatorFn,
  GetBasiqCustomerMappingFn, GetBasiqStatementDataForCompanyFn, RefreshBasiqConnectionsFn, GetBankStatementAndBasiqDataStatusFn,
  GetDscrCalculatorHistoryFn,
  AddAuditLogFn,
  RunCreditFlowFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  GetCreditAuditLogFn,
  ApplicationSelectionObject,
  GetWebServiceReportFn,
  GetDuplicatedApplicationsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  RequestMoreInformationFn,
  WithdrawApplicationFn,
  PortalLoginUser,
  GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  ResendContractFn,
  AggregatorAndOriginatorListValueGetFn,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  NewWebService,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
} from '@portal-workspace/grow-shared-library';
import { BreadcrumbComponentEvent, BreadcrumbComponent } from '../../breadcrumb-component/breadcrumb.component';
import {PaymentChartData} from '@portal-workspace/grow-shared-library';
import {ApplicationSelectionType} from '@portal-workspace/grow-shared-library';
import {
  ApproveApplicationDocumentFn,
  CompleteDocumentWorklistFn,
  CreateDocumentWorklistFn,
  DeclineApplicationDocumentFn,
  DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn,
  DownloadAllApplicationDocumentUrlFn,
  DownloadApplicationDocumentUrlFn,
  GetOriginatorByIdFn,
  getUser,
  ListApplicationDocumentFn,
  
  setupUntilDestroy,
  UpdateApplicationDocumentTagsFn,
  UpdateApplicationRequiredDocumentsFn,
  PortalHotToastService,
  ApplicationDialogService,
  AssetSettlementAddPpsrDetailFn,
  AssetSettlementGetApplicationPpsrInfoFn,
  AssetSettlementGetPpsrDetailsFn,
  AssetSettlementGetPpsrDocumentsFn,
  AssetSettlementRemoveApplicationAssetFn,
  AssetSettlementSavePpsrDocumentFn,
  AssetSettlementSearchAssetsFn,
  AssetSettlementSearchGrantorsFn,
  AssetSettlementSendAssetToSfFn,
  AssetSettlementSubmitApplicationAssetsFn,
  AssetSettlementUpdateApplicationAssetsFn,
  AssetSettlementUpdatePpsrDetailFn,
  SearchSupplierFn,
  SaveSupplierFn,
  BusinessSearchFn,
  BusinessNumberSearchFn,
  applicationDefaultDocuments,
  UndoApplicationDocumentFn,
  BusinessOverdraftTab,
  AssetSelectionComponentSearchFn,
  AssetDocumentsComponent,
} from '@portal-workspace/grow-ui-library';
import {switchMap, tap} from 'rxjs/operators';
import {
  applicationEntityDisplayName,
  getAbn,
  getAcn,
  getAdverseOnFile,
  getApplicationNotes,
  getAssetCategory,
  getAssetCondition,
  getAssetDescription,
  getAssetFamily,
  getAssetMake,
  getAssetType,
  getAssetYear,
  getBrokerage,
  getBrokerApplicationId,
  getBrokerName,
  getBrokerSalesforceId,
  getCompanyName,
  getDeposit,
  getDocFeeFinanced,
  getEquifaxScoreAboveThresold,
  getFinanceType,
  getIndustrySector,
  getInterestRate,
  getInvoiceAmount,
  getLoanAmount,
  getLoanTerms,
  getOrganisationType, getPrimaryBusinessAddress,
  getPrivateSales,
  getPropertyOwner,
  getRepaymentFrequency,
  getRevenue,
  getPaymentType,
  DigitalIdGetApplicationIndividualsFn,
  AssetSettlementGetApplicationAssetFn,
  getApplicationStage,
  applicationStageAllowSettleLoan,
  DocumentTag,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
} from '@portal-workspace/grow-shared-library';
import {UntilDestroy} from '@ngneat/until-destroy';
import {combineLatest, of, Subscription} from 'rxjs';
import {GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent } from '@portal-workspace/grow-ui-library';
import {UpdateApplicationDocumentFn} from '../application-details.module';
import {GetApplicationAuditLogsFn} from '../../asset-listing-component/audit-log.component';
import {GetNotesByApplicationIdFn} from '../../asset-listing-component/notes.component';
import { UpdateDocumentMetadataFn, AddAssetComponent } from '../../asset-listing-component/add-asset.component';
import { ConsumerAssetDocumentsComponent } from './consumer-documents.component';
import { KycVerificationComponent } from '../kyc-verification.component';
import { confirmLeaveKycAmlTab } from '../kyc-unsaved-tab-guard';
import { AssetSettlementComponent } from '../asset/asset-settlement.component';
import { ConsumerAppComponent } from './consumer-app.component';
import { MatMenuModule } from '@angular/material/menu';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import { ApplicationStageIconComponent } from '../application-stage-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { BankComponent } from '../bank.component';
import { ConsumerPricingComponent } from './consumer-pricing.component';
import {ConsumerCreditComponent} from "./consumer-credit.component";
import {ApplicationTypeIconComponent} from '../../application-type-icon/application-type-icon.component';
import { CreditReportComponent } from '../../credit-component/credit-report.component';

export type ConsumerTab = {selectionTypes: ApplicationSelectionType[], iconClass: string, name: string, index: number};

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
  selector: 'consumer-finance-application-details',
  templateUrl: './consumer-finance-application-details.component.html',
  styleUrls: ['./consumer-finance-application-details.component.scss'],
  standalone: true,
  imports: [
    FlexModule,
    BreadcrumbComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    ApplicationStageIconComponent,
    MatTabsModule,
    MatMenuModule,
    MessageBoxComponent,
    ConsumerAppComponent,
    AssetSettlementComponent,
    AddAssetComponent,
    KycVerificationComponent,
    ConsumerAssetDocumentsComponent,
    BankComponent,
    ConsumerPricingComponent,
    AssetDocumentsComponent,
    ConsumerCreditComponent,
    ApplicationTypeIconComponent,
    CreditReportComponent,
  ]
})
export class ConsumerFinanceApplicationDetailsComponent {

  tabs: BusinessOverdraftTab[] = [];

  // possible selections that can be access directly through URL
  possibleSelections: ApplicationSelectionType[] = ['app', 'quote','asset', 'bank-statement', 'documents', 'kyc-aml', 'pricing', 'credit-report'];

  getCompanyName = getCompanyName;
  getBrokerApplicationId = getBrokerApplicationId;
  getBrokerSalesforceId = getBrokerSalesforceId;
  getBrokerName = getBrokerName;
  getOrganisationType = getOrganisationType;
  getInterestRate = getInterestRate;
  getLoanAmount = getLoanAmount;
  getBrokerage = getBrokerage;
  getAbn = getAbn;
  getAcn = getAcn;
  getFinanceType = getFinanceType;
  getAssetCategory = getAssetCategory;
  getAssetType = getAssetType;
  getAssetMake = getAssetMake;
  getAssetFamily = getAssetFamily;
  getAssetYear = getAssetYear;
  getAssetDescription = getAssetDescription;
  getAssetCondition = getAssetCondition;
  getInvoiceAmount = getInvoiceAmount;
  getLoanTerms = getLoanTerms;
  getPrivateSales = getPrivateSales;
  getEquifaxScoreAboveThreshold = getEquifaxScoreAboveThresold;
  getAdverseOnFile = getAdverseOnFile;
  getPropertyOwner = getPropertyOwner;
  getDocFeeFinanced = getDocFeeFinanced;
  getRepaymentFrequency = getRepaymentFrequency;
  getDeposit = getDeposit;
  getRevenue = getRevenue;
  getIndustrySector = getIndustrySector;
  getApplicationNotes = getApplicationNotes;
  getPrimaryBusinessAddress = getPrimaryBusinessAddress;
  isInternalUser = isInternalUser;
  getAppSalesforceId = getAppSalesforceId;
  getApplicationStage = getApplicationStage;
  getPaymentType = getPaymentType;
  applicationStageAllowSettleLoan = applicationStageAllowSettleLoan;
  groupStandardCondition = groupStandardCondition;
  formGroupedDocumentData = formGroupedDocumentData;
  unclassifiedDocuments = unclassifiedDocuments;
  @Input({required: true}) application!: ConsumerFinanceApplication;

  breadcrumbTrails: string[] = ['Applications'];

  @Input({required: true}) getOriginatorByIdFn!: GetOriginatorByIdFn;
  @Input({required: true}) addIndividualFn!: DigitalIdAddIndividualFn;
  @Input({required: true}) verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  @Input({required: true}) sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  @Input({required: true}) getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  @Input({required: true}) saveApplicationPartiesFn!: SaveApplicationPartiesFn;
  @Input({required: true}) updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  @Input({required: true}) onBreadcrumbEventsFn: (evt: BreadcrumbComponentEvent)=>void = (evt)=>{};
  @Input({required: true}) getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input({required: true}) bankStatementsUrl!: string;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) uploadApplicationDocumentFn!: UpdateApplicationDocumentFn;
  @Input({required: true}) listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input({required: true}) downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input({required: true}) getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;

  @Input({required: true}) approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input({required: true}) declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input({required: true}) deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input({required: true}) downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input({required: true}) updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input({required: true}) updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
   
  @Input({required: true}) createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input({required: true}) completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input({required: true}) assetSearchFn!: AssetSelectionComponentSearchFn;

  @Input({required: false}) initialSelection: ApplicationSelectionType | null = null;
  @Output() selectionEvent: EventEmitter<ApplicationSelectionObject> = new EventEmitter<ApplicationSelectionObject>();
  @Input({required: true}) getApplicationPpsrInfoFn!: AssetSettlementGetApplicationPpsrInfoFn;
  @Input({required: true}) removeApplicationAssetFn!: AssetSettlementRemoveApplicationAssetFn;
  @Input({required: true}) searchAssetFn!: AssetSettlementSearchAssetsFn;
  @Input({required: true}) searchSupplierFn!: SearchSupplierFn;
  @Input({required: true}) saveSupplierFn!: SaveSupplierFn;
  @Input({required: true}) businessSearchFn!: BusinessSearchFn;
  @Input({required: true}) getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input({required: true}) sendAssetToSfFn!: AssetSettlementSendAssetToSfFn;
  @Input({required: true}) getPpsrDetailsFn!: AssetSettlementGetPpsrDetailsFn;
  @Input({required: true}) addPpsrDetailFn!: AssetSettlementAddPpsrDetailFn;
  @Input({required: true}) updatePpsrDetailFn!: AssetSettlementUpdatePpsrDetailFn;
  @Input({required: true}) updateApplicationAssetsFn!: AssetSettlementUpdateApplicationAssetsFn;
  @Input({required: true}) submitApplicationAssetsFn!: AssetSettlementSubmitApplicationAssetsFn;
  @Input({required: true}) searchGrantorsFn!: AssetSettlementSearchGrantorsFn;
  @Input({required: true}) getPpsrDocumentsFn!: AssetSettlementGetPpsrDocumentsFn;
  @Input({required: false}) savePpsrDocumentFn!: AssetSettlementSavePpsrDocumentFn;
  @Input({required: true}) assetSettlementSearchAssetsFn!: AssetSettlementSearchAssetsFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) updateDocumentMetadataFn!: UpdateDocumentMetadataFn;
  @Input({required: true}) getContractStatusFn!: GetContractStatusFn;
  @Input({required: true}) getActiveContractForApplicationFn!: GetActiveContractForApplicationFn;
  @Input({required: true}) declineContractFn!: DeclineContractFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) createNewDisbursementFn!: CreateNewDisbursementFn;
  @Input({required: true}) updateDisbursementFn!: UpdateDisbursementFn;
  @Input({required: true}) getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input({required: true}) syncDisbursementToSfFn!: SyncDisbursementToSfFn;
  @Input({required: true}) syncBankDetailsToSfFn!: SyncBankDetailsToSfFn;
  @Input({required: true}) syncPrivateSellerBankDetailsToSfFn!: SyncPrivateSellerBankDetailsToSfFn;
  @Input({required: true}) syncDepositPaidToSfFn!: SyncDepositPaidToSfFn;
  @Input({required: true}) businessNumberSearchFn!: BusinessNumberSearchFn;
  @Input({required: true}) getBillerNameFn!: GetBillerNameFn;
  @Input({required: true}) getInstitutionNameFn!: GetInstitutionNameFn;
  @Input({required: true}) validateBpayFn!: ValidateBPAYFn;
  @Input({required: true}) updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) settleLoanFn!: SettleLoanFn;
  @Input({required: true}) generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input({required: true}) sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input({required: true}) deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input({required: true}) undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input({required: true}) refreshBankStatementFn!: RefreshBankStatementFn;
  @Input({required: true}) getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  @Input({required: true}) getBankDetailsFromOpportunitySfFn!: GetBankDetailsFromOpportunitySfFn;
  @Input({required: true}) allowContractGeneration!: boolean;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) extractTaxInvoiceFn!: ExtractTaxInvoiceFn;
  @Input({required: true}) updateApplicationFn!: UpdateApplicationFn;
  @Input({required: true}) updateApplicationSfFn!: UpdateApplicationSfFn;
  @Input({required: true}) createAssetInspectionFn!: CreateAssetInspectionFn;
  @Input({required: true}) getAssetInspectionsForApplicationFn!: GetAssetInspectionsForApplicationFn;
  @Input({required: true}) downloadVerimotoReportFn!: DownloadVerimotoReportFn;
  @Input({required: true}) verimotoLender!: VerimotoLenderType;
  @Input({required: false}) verimotoAssetInspectionTypes!: VerimotoInspectionTypeSelection[];
  @Input({required: true}) downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  @Input({required: true}) getBsaLenderListFn!: GetBsaLenderListFn;
  @Input({required: true}) getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  @Input({required: true}) getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  @Input({required: true}) updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;
  @Input({required: true}) saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  @Input({required: true}) getBsaCalculatorFn!: GetBsaCalculatorFn;
  @Input({required: true}) getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  @Input({required: true}) getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  @Input({required: true}) getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  @Input({required: true}) getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  @Input({required: true}) refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;
  @Input({required: true}) addAuditLogFn!: AddAuditLogFn;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) resendContractFn!: ResendContractFn;
  @Input({required: true}) getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({required: true}) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({required: true}) getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input({required: true}) updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  @Input() syncIndividualKycFromFrankieOneFn?: DigitalIdSyncIndividualKycFromFrankieOneFn;


  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() navigateToApplications = new EventEmitter();
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;
  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();

  activeContract: ContractDetails | null = null;

  assetInspectionTableData: VerimotoInspectionTableDataWithInspectionDetails[] = [];

  // Consumer Asset Finance is decommissioned: legacy applications still need a paymentChartData
  // shape to satisfy <asset-settlement>'s disbursement table, but no recalculation is performed.
  paymentChartData: PaymentChartData = {
    amountFinanced: 0,
    totalInterest: 0 ,
    emiAmt: 0,
    paymentFrequency: 'Monthly',
    principalAmt: 0,
    interestAmt: 0,
    totalAmt: 0,
    loanTerm: 0,
    lvr: 0,
    rv: 0,
    brokerageAmount: 0,
    docFee: 0,
    brokerOriginationFee: 0,
    applicationType:'Consumer',
    monthlyAccountKeepingFee: 0,
  };

  subscriptions: Subscription[] = [];
  loggedInUser: PortalLoginUser | null = getUser();
  isDealer: boolean = false;


  currentSection: ApplicationSelectionType = 'app';
  currentSectionIndex: number = 0;
  sendToSF !: boolean;

  editAssetValue!: PpsrAssetValue
  ppsrChecked!: boolean;
  ppsrRegistered = false;
  assetStatus:any=[];
  isSettledLoan: boolean = false
  allAssetAccepted : boolean = false
  isAssetEmpty: boolean = false;
  missingBankDetails: null | 'customer' | 'broker' = null;

  @ViewChild(KycVerificationComponent) kycVerification?: KycVerificationComponent;

  constructor(private toastService: PortalHotToastService,
              private dialogService: ApplicationDialogService,
              private applicationDialogService: ApplicationDialogService,
  ) {}

  initTabs() {
    this.tabs = [];
    this.tabs.push({selectionTypes: ['app'], iconClass: 'mdi-view-grid-outline', name: 'APPLICATION', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['bank-statement'], iconClass: 'mdi-bank-outline', name: 'BANK STATEMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['kyc-aml'], iconClass: 'mdi-check-decagram-outline', name: 'CUSTOMER DETAILS(KYC/AML)', index:(this.tabs.length)});
    if (isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['credit', 'credit-report'], iconClass: 'mdi-calculator', name: 'CREDIT', index: (this.tabs.length)});
    }
    this.tabs.push({selectionTypes: ['documents'], iconClass: 'mdi-folder-outline', name: 'DOCUMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['asset', 'add-asset'], iconClass: 'mdi-handshake-outline', name: 'CONTRACT', index: (this.tabs.length)});
    if (isAdminOrCreditUserOrSalesAM(this.loggedInUser) || isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['pricing'], iconClass: 'mdi-currency-usd', name: 'PRICING', index: (this.tabs.length)});
    }
  }

  hasUnsavedKycChanges(): boolean {
    return this.currentSection === 'kyc-aml' && !!this.kycVerification?.hasUnsavedChanges();
  }

  unsavedKycChangeLabels(): string[] {
    return this.kycVerification?.unsavedChangeLabels() ?? [];
  }

  async onSelectedTabChange(event: MatTabChangeEvent) {
    const previousSection = this.currentSection;
    const tabFound = this.tabs.find(t => t.index == event.index);
    const selection = tabFound ? tabFound.selectionTypes[0] : 'app' /* default selection if not found */ ;
    const canLeave = await confirmLeaveKycAmlTab({
      previousSection,
      nextSection: selection,
      kycVerification: this.kycVerification,
      dialogService: this.dialogService,
      revertToKycTab: () => {
        const kycTab = this.tabs.find(t => t.selectionTypes.includes('kyc-aml'));
        if (kycTab) {
          this.currentSectionIndex = kycTab.index;
        }
      },
    });
    if (!canLeave) {
      return;
    }
    this.currentSection = selection;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  showAddAsset() {
    this.currentSection = 'add-asset';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  ngOnInit() {
    this.isDealer = !!this.loggedInUser?.priviledges?.includes('dealer');
    this.initTabs();
    const routeTab = this.initialSelection;
    if (routeTab && this.possibleSelections.includes(routeTab)) {
      const _tab = this.tabs.find(tab => tab.selectionTypes.includes(routeTab));
      if (_tab) {
        this.currentSection = routeTab;
        this.currentSectionIndex = _tab.index;
      }
    }
    setupUntilDestroy(this);
    const user = getUser();
    const entityName = applicationEntityDisplayName(this.application);
    if (entityName) {
      this.breadcrumbTrails.push(entityName);
    }
    this.getApplicationAsset();
    this.getActiveContract();
    this.getBankDetails();
    this.loadAssetInspections();
  }

  loadAssetInspections() {
    this.subscriptions.push(
      this.getAssetInspectionsForApplicationFn(this.application.ApplicationId).pipe(
      ).subscribe((data: VerimotoInspectionTableDataWithInspectionDetails[]) => {
        console.log('===asset inspections: ', data);
        this.assetInspectionTableData = data;
      })
    )
  }

  onViewReport(element: NewWebService) {
    this.currentSection = 'credit-report';
    console.log(this.currentSection)
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: String(element.id),
    });
  }

  onLeaveReport(event: any) {
    this.currentSection = 'credit';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  getApplicationAsset() {
    this.subscriptions.push(
      this.getApplicationAssetFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe(res => {
        if (res.length) {
          if (res[0].AssetSFRes !== null && res[0].AssetSFRes !== undefined) {
            this.isSettledLoan = true
          }
          this.assetStatus = res.filter(r => r.status === 'accepted');
          if (res.length !== this.assetStatus.length) {
            this.allAssetAccepted = true
          }
          else {
            this.allAssetAccepted = false
          }
        } else {
          this.isSettledLoan = false;
        }
      })
    )
  }

  onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    this.onBreadcrumbEventsFn($event);
  }

  getEvent() {
    this.currentSection = "asset"
    this.editAssetValue = null;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  getAssetSave() {
    this.currentSection = "asset"
    this.editAssetValue = null;
    this.isAssetEmpty = false;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  onEditAssetEvent($event: PpsrAssetValue) {
    this.editAssetValue = $event;
    this.currentSection = 'add-asset'
  }

  onPPSRCheckAll(element: any) {
    let ppsrAsset: PpsrAsset[] = [];
    let ppsrError = false;

    this.applicationDialogService.openPPSRCheckDialog()
      .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.getApplicationAssetFn(this.application.ApplicationId)
              .pipe(
                switchMap((res: PpsrAsset[]) => {
                  const subs = [];
                  for (let i = 0; i < res.length; i++) {
                    this.ppsrChecked = false;
                    if (res[i].SettlementAssetDetails?.serialNumber !== null && res[i].SettlementAssetDetails?.serialNumberType !== null && (res[i].PPSRStatus === 'unchecked' || res[i].PPSRStatus === 'issue')) {
                      ppsrAsset.push(res[i]);
                      subs.push(
                        this.assetSettlementSearchAssetsFn(this.application.ApplicationId, {
                          SearchNumber: res[i].SettlementAssetDetails?.serialNumber,
                          NumberType: (res[i].SettlementAssetDetails?.serialNumberType as string).replace(/ +/g, ''),
                        })
                      )
                    }
                  }
                  if (!subs.length) {
                    return of([]);
                  }
                  return combineLatest(subs);
                }),
                this.toastService.spinnerObservable(),
                tap((results: (VehicleDetails | { Error: any } | null)[]) => {
                  if (!results || !results?.length) {
                    this.dialogService.openAlertDialog({
                      message: 'Warn',
                      subMessage: 'PPSR check is already done',
                    });
                  } else {
                    for (let i = 0; i < results.length; i++) {
                      const data = results[i];
                      if (data && (data as { Error: any })?.Error) {
                        let asset: any = {};
                        asset.AssetId = ppsrAsset[i].AssetId;
                        asset.PPSRStatus = 'issue';
                        this.updateAssetsToDatabase(asset, 'save')
                        ppsrError = true;
                      } else if (data && !(data as { Error: any })?.Error) {
                        let asset: any = {};
                        asset.AssetId = ppsrAsset[i].AssetId;
                        asset.SettlementAssetDetails = ({
                          assetCategory: ppsrAsset[i].SettlementAssetDetails?.assetCategory,
                          assetType: ppsrAsset[i].SettlementAssetDetails?.assetType,
                          description: ppsrAsset[i].SettlementAssetDetails?.description,
                          serialNumberType: ppsrAsset[i].SettlementAssetDetails?.serialNumberType,
                          serialNumber: ppsrAsset[i].SettlementAssetDetails?.serialNumber,
                          InvoicePrice: ppsrAsset[i].SettlementAssetDetails?.InvoicePrice,
                          GST: ppsrAsset[i].SettlementAssetDetails?.GST,
                          year: ppsrAsset[i].SettlementAssetDetails?.year,
                          supplier: ppsrAsset[i].SettlementAssetDetails?.supplier,
                          VehicleDetails: data,
                        })
                        asset.PPSRStatus = 'confirmed';
                        this.updateAssetsToDatabase(asset, 'save')
                      }
                    }

                    if (ppsrError) {
                      this.dialogService.openAlertDialog({
                        message: 'Error',
                        subMessage: 'Please try after sometime',
                      });
                    } else {
                      this.dialogService.successDialog({
                        message: 'Success',
                        subMessage: 'PPSR check completed',
                      });
                    }
                  }
                })
              ).subscribe(() => { this.ppsrChecked = true; }) // refresh the table
          }
        })
      ).subscribe();
  }

  async updateAssetsToDatabase(assetUpdateData: PpsrAsset, key: string) {
    this.updateApplicationAssetsFn(assetUpdateData).pipe(
      this.toastService.spinnerObservable(),
      this.toastService.snackBarObservable('Asset Updated'),
      tap(r => {
        console.log("success")
      }
      )).subscribe();
  }

  getBankDetails() {
    if (this.application.AppInfo.BrokerSalesforceID && this.application.AppInfo.CustomerId) {
      this.subscriptions.push(
        combineLatest([
          this.getAccountDetailsFromSfFn(this.application.BrokerSalesforceId),
          this.getAccountDetailsFromSfFn(this.application.AppInfo.CustomerId ?? ""),
        ]).pipe(
          switchMap(([brokerBankDetails, customerBankDetails]: [LocalBankAccountDetailValue, LocalBankAccountDetailValue]) => {
            console.log('brokerBankDetails, customerBankDetails: ', brokerBankDetails, customerBankDetails)
            this.missingBankDetails = null;
            if (!brokerBankDetails?.AccountNumber || !brokerBankDetails?.BSB || !brokerBankDetails.AccountName) {
              this.missingBankDetails = 'broker';
              return of(null);
            } else if (!customerBankDetails?.AccountNumber || !customerBankDetails.BSB || !customerBankDetails.AccountName) {
              return this.getBankDetailsFromOpportunitySfFn(this.application.AppInfoSalesforceID ?? "");
            } else {
              return of(customerBankDetails);
            }
          })
        ).subscribe((result: LocalBankAccountDetailValue) => {
          if ((!result?.AccountNumber || !result?.BSB || !result?.AccountName) && this.missingBankDetails !== 'broker') {
            this.missingBankDetails = 'customer';
          }
          console.log('customer bank details on oppo level: ', result);
        })
      )
    }
  }

  applicationDocumentTypes(application: Application) {
    const tags = application?.DocumentTypes?.length ? application?.DocumentTypes.map(t => {
      return {
        ...t,
        value: t.value.toLowerCase()
      }
    }) : [];
    const documentTypes: DocumentTag[] = [];
    for (const tag of tags) {
      if (!documentTypes.map(t => t.value).includes(tag.value)) {
        documentTypes.push(tag)
      }
    }
    return documentTypes;
  }

  onSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.applicationDialogService.openSettleLoanDialog(true)
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.doSendAssetAndDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      this.applicationDialogService.openSettleLoanDialog(false).afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            // check documents first
            this.subscriptions.push(
              combineLatest([
                this.listApplicationDocumentFn(this.application.ApplicationId),
                this.getApplicationByIdFn(this.application.ApplicationId)
              ]).pipe(
                this.toastService.spinnerObservable()
              ).subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
                if (r) {
                  let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
                    app?.DocumentTypes?.length ? app?.DocumentTypes
                    : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
                    '',
                  );
                  docs = this.groupStandardCondition(docs, this.application);
                  docs = this.displayRequiredDocumentsOnly(docs);
                  const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
                  const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
                  const standardConditionDocs = docs.filter(d => d?.standardCondition);
                  const pendingGroups = [
                    ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
                  ];
                  if (pendingGroups.length) {
                    // do not allow settle loan
                    this.applicationDialogService.openAlertDialog({
                      message: 'Error',
                      subMessage: 'You cannot settle loan as you still have pending documents',
                    }).afterClosed().subscribe();
                  } else {
                    this.doUpdateApplicationStage();
                  }
                }
              })
            )
          }
        })
      ).subscribe()
    }
  }

  doUpdateApplicationStage() {
    this.subscriptions.push(
      this.updateApplicationStageFn({
        salesforceId: this.application.AppInfoSalesforceID ?? "",
        stageName: 'QA'
      }).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response.status) {
          this.applicationDialogService.successDialog({
            message: 'Success',
            subMessage: "Application sent to QA queue",
          }).afterClosed().subscribe();
        } else {
          this.applicationDialogService.openAlertDialog({
            message: 'Error',
            subMessage: response.message,
          }).afterClosed().subscribe();
        }
      })
    )
  }

  doSendAssetAndDisbursementToSf() {
    this.subscriptions.push(
      combineLatest([
        this.getApplicationAssetFn(this.application.ApplicationId),
        this.getDisbursementByApplicationIdFn(this.application.ApplicationId)
      ]).pipe(
        switchMap(([assets, disbursements]: [PpsrAsset[], Disbursement[]]) => {
          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }

          return this.settleLoanFn({
            assets: assets,
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? ""
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }
        // reload asset table
        this.getApplicationAsset();
      })
    )
  }

  emptyAssetFn($event: any) {
    console.log('asset-finance', $event);
    this.isAssetEmpty = $event;
  }

  assetAcceptedFn($event: any) {
    this.isSettledLoan = $event;
  }

  disableSettleLoan($event: any){
    this.isSettledLoan = $event
    this.allAssetAccepted = $event
  }

  disableOnPPSRStatus($event: any){
    this.allAssetAccepted = $event
  }

  getActiveContract() {
    this.subscriptions.push(
      this.getActiveContractForApplicationFn(this.application.ApplicationId)
        .subscribe((r: ContractDetails | null) => {
          this.activeContract = r;
        })
    )
  }

  openContractStatusDialog() {
    this.subscriptions.push(
      this.applicationDialogService.openContractStatusDialog({
        getContractStatusFn: this.getContractStatusFn,
        applicationId: this.application.ApplicationId,
        declineContractFn: this.declineContractFn,
        envelopeId: this.activeContract?.envelopeId ?? "",
        resendContractFn: this.resendContractFn,
      }).afterClosed().subscribe(() => {
        this.getActiveContract();
      })
    )
  }

  private displayRequiredDocumentsOnly(docs: GroupedDocument[]) {
    return docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
